import _uniq from 'lodash.uniq';

const ASSET_KEY = 'assetId';
const ASSETS_KEY = 'assetIds';

function isObject(value) {
  return Boolean(value && typeof value === 'object');
}

function findAssetIds(data) {
  if (!isObject(data)) {return [];}

  if (Array.isArray(data)) {
    return data.reduce((assetIds, dataValue) => [
    ...assetIds,
    ...findAssetIds(dataValue)],
    []);
  }

  return Object.keys(data).reduce((assetIds, key) => {
    const dataValue = data[key];

    if (!dataValue) {return assetIds;}

    if (key === ASSET_KEY || key === ASSETS_KEY) {
      const args = Array.isArray(dataValue) ?
      dataValue :
      [dataValue];

      return [...assetIds, ...args];
    }

    if (!isObject(dataValue)) {
      return assetIds;
    }

    return [...assetIds, ...findAssetIds(dataValue)];
  }, []);
}

export default function findAllAssetIds(data, callback) {
  if (!isObject(data)) {return [];}

  const assetIds = findAssetIds(data);

  if (!assetIds.length) {return [];}

  if (callback) {
    callback(_uniq(assetIds));
  }
  return _uniq(assetIds);
}